export default __webpack_public_path__ + "static/media/spectra-com15.2ced7d91.jpg";